import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SelectFilter from './SelectFilter';

/**
 * Supplier-accreditation filter, used on the Supplier and Purchase Order lists.
 *
 * Built on SelectFilter so it looks and behaves like the other filters on these
 * pages (the PO status filter is the same control), rather than introducing a
 * second filter style.
 *
 * Defaults to "All suppliers" so the normal day-to-day view is unchanged.
 * "Accredited only" is the audit view -- "only list of accredited should appear
 * ... meaning only their PO's should appear". The choice is written to the
 * `accredited` URL param, so it survives a refresh and can be shared as a link.
 */
const ALL = 'all';
const YES = 'true';
const NO = 'false';

const AccreditedFilter = ({
  className = 'w-48',
}: {
  className?: string | undefined;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const current =
    searchParams.get('accredited') === YES
      ? YES
      : searchParams.get('accredited') === NO
        ? NO
        : ALL;

  const handleChange = (value: string) => {
    setSearchParams((prev) => {
      if (value === YES || value === NO) prev.set('accredited', value);
      else prev.delete('accredited');
      return prev;
    });
  };

  return (
    <SelectFilter
      className={className}
      handleChange={handleChange}
      defaultValue={current}
      dataOptions={[
        { label: 'All suppliers', value: ALL },
        { label: 'Accredited only', value: YES },
        { label: 'Not accredited', value: NO },
      ]}
    />
  );
};

export default AccreditedFilter;
